import React from 'react'
import { createBrowserRouter, Outlet } from 'react-router-dom'
import { render } from 'react-dom'
import { Router } from '@remix-run/router'
import { Main } from './Components/Main'
import { RouterContainer } from './Common/RouterContainer'
import { BaseContexts } from '../React/Common/BaseContexts'
import { routerState$ } from '../NonReact/common/RxJS/RouterState'
import { Route } from '../NonReact/Types/Types'
import './Pages'
import { ErrorView } from './Components/Organisms/Error/ErrorView'
import { initFusionThemeBridge } from '../NonReact/common/FusionThemeBridge'
import { initFusionSignInAsHandoff } from '../NonReact/common/FusionReauthBridge'

// Sync dark mode with the new-UI host when this v2 page is embedded as a portal iframe (the CCS
// header, and therefore useDarkMode, is not mounted in portal mode).
initFusionThemeBridge()

// If a legacy "Sign-In As" switch was just submitted, hand the now-switched session up to the host
// so it adopts the impersonated user and routes to the realtime dashboard (CXUI-402).
initFusionSignInAsHandoff()

routerState$.subscribe((routes: Route[]): void => {
    const router: Router = createBrowserRouter(
        [
            {
                element: (
                    <RouterContainer>
                        <Outlet />
                    </RouterContainer>
                ),
                children: routes,
                hasErrorBoundary: true,
                errorElement: <ErrorView />
            }
        ],
        {
            basename: '/CCS/App/v2'
        }
    )

    render(
        <BaseContexts isRouterMode={true}>
            <Main router={router} />
        </BaseContexts>,
        document.getElementById('react-root')
    )
})
